import api from "./api";
import { toast } from "react-toastify";

class StaffService {
  addKeyToNestedArray(array) {
    return array.map((item, index) => {
      const updatedItem = {
        ...item,
        id: item.bp_designation_id.toString(),
        name: item.designation,
        type: "designation",
      };

      if (item.designations && item.designations.length > 0) {
        updatedItem.designations = this.addKeyToNestedArray(
          updatedItem.designations
        );
      }

      return updatedItem;
    });
  }
  async getStaffUser(kapid_id) {
    try {
      const response = await api
        .get(`/staff/?kapid_id=${kapid_id}`)
        .then((res) => res.data);
      if (response.success) {
        const user = response.response;
        return user;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }

  async getRolesDesignations() {
    try {
      const response = await api
        .get("/staff/roles-designations/")
        .then((res) => res.data);
      if (response.success) {
        const roles = response.response;
        roles.map((role) => {
          role.id = "role_" + role.bp_role_id;
          role.name = role.role_name;
          role.type = "role";
          if (role.designations && role.designations.length > 0)
            role.designations = this.addKeyToNestedArray(role.designations);
          return role;
        });
        return roles;
      } else throw new Error(response.response);
    } catch (error) {
      toast.error(error.message);
      console.log(error);
      return false;
    }
  }

  async getStaffTypes() {
    try {
      const response = await api
        .get(`/staff/staff-types/`)
        .then((res) => res.data);
      if (response.success) {
        const stypes = response.response;
        return stypes;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
  async getEmpPosds(emp_id) {
    try {
      const response = await api
        .get(`/staff/${emp_id}/posds/`)
        .then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
  async getEmpSpls(emp_id) {
    try {
      const response = await api
        .get(`/staff/${emp_id}/spls`)
        .then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }

  async newStaff(staff) {
    try {
      const response = await api
        .post("/staff/new/", staff)
        .then((res) => res.data);
      if (response.success) {
        // toast.success(response.response);
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
}

const staffService = new StaffService();
export default staffService;
